/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx } from '@emotion/react'
import { type FunctionComponent } from 'react'

import { EuiConfirmModal, useGeneratedHtmlId } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import type { Budget } from '../types'

type Props = {
  budget: Budget
  onCancel: () => void
  onConfirm: () => void
}

const DeleteBudgetModal: FunctionComponent<Props> = ({ budget, onCancel, onConfirm }) => {
  const deleteBudgetModalTitleId = useGeneratedHtmlId()

  return (
    <EuiConfirmModal
      aria-labelledby={deleteBudgetModalTitleId}
      title={
        <FormattedMessage
          id='billing.notifications.budgets.table.delete-conformation.title'
          defaultMessage='Delete budget?'
        />
      }
      onCancel={onCancel}
      onConfirm={onConfirm}
      cancelButtonText={
        <FormattedMessage
          id='billing.notifications.budgets.table.delete-conformation.cancel'
          defaultMessage='Cancel'
        />
      }
      confirmButtonText={
        <FormattedMessage
          id='billing.notifications.budgets.table.delete-conformation.confirm'
          defaultMessage='Delete budget'
        />
      }
      buttonColor='danger'
    >
      <FormattedMessage
        id='billing.notifications.budgets.table.delete-conformation.description'
        defaultMessage='You will permanently delete the budget "{budgetName}" and all associated alerts. This action cannot be undone.'
        values={{ budgetName: budget.name }}
      />
    </EuiConfirmModal>
  )
}

export default DeleteBudgetModal
